export default function Podcast() {
  return (
    <div className="page-panel">
      <div className="panel-inner">

        <div className="panel-header">
          <div className="panel-tag">Podcast</div>
          <h2 className="panel-title">Product<br />Design<br />1 on 1</h2>
          <p className="panel-subtitle">
            A podcast about design careers, leadership, and building culture —
            co-hosted by Rice Tseng &amp; Liya Li.
          </p>
        </div>

        <div className="podcast-hero">
          <div className="podcast-cover">
            <img src="/image-7-podcast.png" alt="Product Design 1 on 1 Podcast" />
          </div>

          <div className="podcast-meta">
            <div className="podcast-stat">
              <div className="podcast-stat-num">115K+</div>
              <div className="podcast-stat-label">Total Downloads</div>
            </div>
            <div className="podcast-stat">
              <div className="podcast-stat-num">56K+</div>
              <div className="podcast-stat-label">Listeners Worldwide</div>
            </div>
            <div className="podcast-stat">
              <div className="podcast-stat-num">15+</div>
              <div className="podcast-stat-label">Designer Interviews</div>
            </div>
          </div>
        </div>

        <div className="section-heading">About the Show</div>

        <div className="about-intro">
          <div className="about-intro-text">
            <p>
              Product Design 1 on 1 is a design podcast focused on the soft skills behind
              great product work — the parts that don't show up in portfolios but shape careers.
            </p>
            <p>
              We talk to designers from across the industry about career growth, building
              design cultures, leadership, navigating organisations, and what it actually
              takes to do meaningful work at scale.
            </p>
          </div>
          <div className="about-intro-meta">
            <div className="about-meta-item">
              <div className="about-meta-label">Topics</div>
              <div className="about-meta-value">
                Design careers · Leadership<br />
                Culture · Product thinking
              </div>
            </div>
            <div className="about-meta-item">
              <div className="about-meta-label">Hosts</div>
              <div className="about-meta-value">
                Rice Tseng &amp; Liya Li
              </div>
            </div>
          </div>
        </div>

        <div className="section-heading">Listen</div>

        <div className="podcast-links" style={{ marginBottom: 80 }}>
          <a
            href="https://productdesign1on1.com/"
            className="podcast-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Website <span className="podcast-link-arrow">↗</span>
          </a>
          <a
            href="https://podcasts.apple.com/us/podcast/product-design-1-on-1/id1521833729"
            className="podcast-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Apple Podcasts <span className="podcast-link-arrow">↗</span>
          </a>
          <a
            href="https://open.spotify.com/show/3ptkQxbdv3rifG7ukGbGfS"
            className="podcast-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Spotify <span className="podcast-link-arrow">↗</span>
          </a>
          <a
            href="https://www.instagram.com/productdesign1on1/"
            className="podcast-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram <span className="podcast-link-arrow">↗</span>
          </a>
        </div>

      </div>
    </div>
  )
}
